import { render } from "./MusoraIcon.vue?vue&type=template&id=a28cf710&scoped=true"
import script from "./MusoraIcon.vue?vue&type=script&lang=js"
export * from "./MusoraIcon.vue?vue&type=script&lang=js"

import "./MusoraIcon.vue?vue&type=style&index=0&id=a28cf710&scoped=true&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28cf710"]])

export default __exports__